import { apiClient, ApiClientConfig, PaginatedRequestParams } from 'api';
export type CreateLabelDTO = {
  title?: string;
  description?: string | null;
};
export const RatingApiService = () => {
  const baseURL = process.env.REACT_APP_BASE_V2_URL;
  const getRatingList = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/facilityratinglist`,
      params,
    });

    return response.data;
  };
  const getRatingReport = async (facilityId: string) => {
    const response = await apiClient({
      endpoint: `${baseURL}/facilityratinglist/${facilityId}`,
      method: 'GET',
      config: {
        responseType: 'blob',
      },
    });

    return response;
  };

  return {
    getRatingList,
    getRatingReport,
  };
};
